import { environment } from '../../../environments/environment'
import { SelectOption } from '../../shared/components/select/select';
import { TableColumn } from '../../shared/components/table/table';
import { FilterField } from '../../shared/components/filter-bar/filter-bar';

export const requests = {
    //auth
    login: environment.baseUrl + '/loginUser',
    azureCallback: environment.baseUrl + '/azureCallback',
    logout: environment.baseUrl + '/logoutUser',
    getAllLookups: environment.baseUrl + '/getAllLookups',
    createBrand: environment.baseUrl + '/createBrand',
    updateBrand: environment.baseUrl + '/updateBrand',
    deleteBrand: environment.baseUrl + '/deleteBrand',
    getAllBrands: environment.baseUrl + '/getAllBrands',
    getAllCountries: environment.baseUrl + '/getAllCountries',
    assignCountryToUser: environment.baseUrl + '/assignCountryToUser',
    getAllAssignedCountries: environment.baseUrl + '/getAllAssignedCountries',
    getAllCurrencies: environment.baseUrl + '/getAllCurrencies',
    updateExchangeRate: environment.baseUrl + '/updateExchangeRate',
    createCustomerCategory: environment.baseUrl + '/createCustomerCategory',
    updateCustomerCategory: environment.baseUrl + '/updateCustomerCategory',
    deleteCustomerCategory: environment.baseUrl + '/deleteCustomerCategory',
    getAllCustomerCategories: environment.baseUrl + '/getAllCustomerCategories',
    createEvidenceType: environment.baseUrl + '/createEvidenceType',
    updateEvidenceType: environment.baseUrl + '/updateEvidenceType',
    deleteEvidenceType: environment.baseUrl + '/deleteEvidenceType',
    getAllEvidenceTypes: environment.baseUrl + '/getAllEvidenceTypes',
    createGroupDescriptionCode: environment.baseUrl + '/createGroupDescriptionCode',
    updateGroupDescriptionCode: environment.baseUrl + '/updateGroupDescriptionCode',
    deleteGroupDescriptionCode: environment.baseUrl + '/deleteGroupDescriptionCode',
    getAllGroupDescriptionCodes: environment.baseUrl + '/getAllGroupDescriptionCodes',
    createItemUom: environment.baseUrl + '/createItemUom',
    updateItemUom: environment.baseUrl + '/updateItemUom',
    deleteItemUom: environment.baseUrl + '/deleteItemUom',
    getAllItemUoms: environment.baseUrl + '/getAllItemUoms',
    createProductCategory: environment.baseUrl + '/createProductCategory',
    updateProductCategory: environment.baseUrl + '/updateProductCategory',
    deleteProductCategory: environment.baseUrl + '/deleteProductCategory',
    getAllProductCategories: environment.baseUrl + '/getAllProductCategories',
    getAllProductTypes: environment.baseUrl + '/getAllProductTypes',
    createReasonCode: environment.baseUrl + '/createReasonCode',
    updateReasonCode: environment.baseUrl + '/updateReasonCode',
    deleteReasonCode: environment.baseUrl + '/deleteReasonCode',
    getAllReasonCodes: environment.baseUrl + '/getAllReasonCodes',
    getAllRegions: environment.baseUrl + '/getAllRegions',
    createReturnReasonCode: environment.baseUrl + '/createReturnReasonCode',
    updateReturnReasonCode: environment.baseUrl + '/updateReturnReasonCode',
    deleteReturnReasonCode: environment.baseUrl + '/deleteReturnReasonCode',
    getAllReturnReasonCodes: environment.baseUrl + '/getAllReturnReasonCodes',
    getAllRoles: environment.baseUrl + '/getAllRoles',
    assignRole: environment.baseUrl + '/assignRole',
    getUserRoles: environment.baseUrl + '/getUserRoles',
    createShipFromLocation: environment.baseUrl + '/createShipFromLocation',
    updateShipFromLocation: environment.baseUrl + '/updateShipFromLocation',
    deleteShipFromLocation: environment.baseUrl + '/deleteShipFromLocation',
    getAllShipFromLocations: environment.baseUrl + '/getAllShipFromLocations',
    createSize: environment.baseUrl + '/createSize',
    updateSize: environment.baseUrl + '/updateSize',
    deleteSize: environment.baseUrl + '/deleteSize',
    getAllSizes: environment.baseUrl + '/getAllSizes',
    createUser: environment.baseUrl + '/createUser',
    updateUser: environment.baseUrl + '/updateUser',
    deleteUser: environment.baseUrl + '/deleteUser',
    getAllUsers: environment.baseUrl + '/getAllUsers',
    importUsersFromFile: environment.baseUrl + '/importUsersFromFile',
    importProductsFromFile: environment.baseUrl + '/importProductsFromFile',
    importCustomersFromFile: environment.baseUrl + '/importCustomersFromFile',
    importVendorsFromFile: environment.baseUrl + '/importVendorsFromFile',
    createDmSite: environment.baseUrl + '/createDmSite',
    updateDmSite: environment.baseUrl + '/updateDmSite',
    deleteDmSite: environment.baseUrl + '/deleteDmSite',
    getAllDmSites: environment.baseUrl + '/getAllDmSites',
    createVariety: environment.baseUrl + '/createVariety',
    updateVariety: environment.baseUrl + '/updateVariety',
    deleteVariety: environment.baseUrl + '/deleteVariety',
    getAllVarieties: environment.baseUrl + '/getAllVarieties',
    getAllDepartments: environment.baseUrl + '/getAllDepartments',
    getAllProducts: environment.baseUrl + '/getAllProducts',
    getAllUserName: environment.baseUrl + '/getAllUserName',
    addNotificationMatrix: environment.baseUrl + '/addNotificationMatrix',
    getAllNotificationMatrix: environment.baseUrl + '/getAllNotificationMatrix',
    deleteNotificationMatrix: environment.baseUrl + '/deleteNotificationMatrix',
    updateNotificationMatrix: environment.baseUrl + '/updateNotificationMatrix',
    getAllCustomers: environment.baseUrl + '/getAllCustomers',
    getAllVendors: environment.baseUrl + '/getAllVendors',
    addApproverMatrix: environment.baseUrl + '/addApproverMatrix',
    getAllApproverMatrices: environment.baseUrl + '/getAllApproverMatrices',
    deleteApproverMatrix: environment.baseUrl + '/deleteApproverMatrix',
    updateApproverMatrix: environment.baseUrl + '/updateApproverMatrix',
    getTaskList: environment.baseUrl + '/getTaskList',
    getCustomerById: environment.baseUrl + '/getCustomerById',
    getAllPort: environment.baseUrl + '/getAllPort',
    getAllCustomerWarehouses: environment.baseUrl + '/getAllCustomerWarehouses',
    getAllShipToLocations: environment.baseUrl + '/getAllShipToLocations',
    getAllApplications: environment.baseUrl + '/getAllApplications',
    getProductTemplate: environment.baseUrl + '/getFile/templates/product.csv',
    getCustomerTemplate: environment.baseUrl + '/getFile/templates/customer.csv',
    getVendorTemplate: environment.baseUrl + '/getFile/templates/vendor.csv',
    getAllCustomerNumbers: environment.baseUrl + '/getAllCustomerNumbers',
    getAllProductLocalItemCodes: environment.baseUrl + '/getAllProductLocalItemCodes',
    getAllVendorNumbers: environment.baseUrl + '/getAllVendorNumbers',
    getFadClaims: environment.baseUrl + '/getFadClaims',
    reassignFadApprover: environment.baseUrl + '/reassignFadApprover',

    // Claim APIs
    createClaim: environment.baseUrl + '/createClaim',
    getClaimList: environment.baseUrl + '/getClaimList',
    getClaimsForLinkage: environment.baseUrl + '/getClaimsForLinkage',
    getClaim: environment.baseUrl + '/getClaim',
    deleteClaim: environment.baseUrl + '/deleteClaim',
    copyClaim: environment.baseUrl + '/copyClaim',
    addClaimOrderInformation: environment.baseUrl + '/addClaimOrderInformation',
    getClaimOrderInformation: environment.baseUrl + '/getClaimOrderInformation',
    getClaimProductInformation: environment.baseUrl + '/getClaimProductInformation',
    addClaimProduct: environment.baseUrl + '/addClaimProduct',
    getAllClaimProducts: environment.baseUrl + '/getAllClaimProducts',
    addClaimEvidence: environment.baseUrl + '/addClaimEvidence',
    uploadFileToStorage: environment.storageServer + '/uploadFile',
    getAllClaimEvidences: environment.baseUrl + '/getAllClaimEvidences',
    deleteClaimEvidence: environment.baseUrl + '/deleteClaimEvidence',
    updateClaimProductQuality: environment.baseUrl + '/updateClaimProductQuality',
    getClaimProductQualityInfo: environment.baseUrl + '/getClaimProductQualityInfo',
    addClaimVesselInfo: environment.baseUrl + '/addClaimVesselInfo',
    getClaimVesselInfo: environment.baseUrl + '/getClaimVesselInfo',
    getClaimDiscountInfo: environment.baseUrl + '/getClaimDiscountInfo',
    submitClaimDmSales: environment.baseUrl + '/submitClaimDmSales',
    submitClaimByDMMarine: environment.baseUrl + '/submitClaimByDMMarine',
    saveAsDraftInDmSales: environment.baseUrl + '/saveAsDraftInDmSales',
    saveAsDraftInDMMarine: environment.baseUrl + '/saveAsDraftInDMMarine',
    updateClaimProductNegotiatedAmount: environment.baseUrl + '/updateClaimProductNegotiatedAmount',
    getClaimActionHistory: environment.baseUrl + '/getClaimActionHistory',
    approveOrRejectClaim: environment.baseUrl + '/approveOrRejectClaim',
    addCreditNoteByFinance: environment.baseUrl + '/addCreditNoteByFinance',
    marketPortQaActionOnSalesClaim: environment.baseUrl + '/marketPortQaActionOnSalesClaim',
    marketPortQaActionOnClonedClaim: environment.baseUrl + '/marketPortQaActionOnClonedClaim',
    sourceQaActionOnClonedClaim: environment.baseUrl + '/sourceQaActionOnClonedClaim',
    marketPortQaCloseClonedClaim: environment.baseUrl + '/marketPortQaCloseClonedClaim',
    marketPortQaActionOnSubmitClaim: environment.baseUrl + '/submitClaimByMarketPortQa',
    marketPortQaActionOnThirdPartyClaim: environment.baseUrl + '/marketPortQaActionOnThirdPartyClaim',
    saveAsDraftInMarketQa: environment.baseUrl + '/saveAsDraftInMarketQa',
    surveyAssignmentOnSalesClaim: environment.baseUrl + '/surveyAssignmentOnSalesClaim',
    getAllSurveyors: environment.baseUrl + '/getAllSurveyors',
    uploadSurveyReport: environment.baseUrl + '/uploadSurveyReport',
    getAllSurveyReports: environment.baseUrl + '/getAllSurveyReports',
    RHOActionOnSurveyReport: environment.baseUrl + '/RHOActionOnSurveyReport',
    addCreditNotesByRHO: environment.baseUrl + '/addCreditNotesByRHO',
    closeClaimByRHO: environment.baseUrl + '/closeClaimByRHO',
    addCreditNoteByProcurement: environment.baseUrl + '/addCreditNoteByProcurement',
    closeClaimByProcurement: environment.baseUrl + '/closeClaimByProcurement',
    addFinalNegotiatedAmountByMarine: environment.baseUrl + '/addFinalNegotiatedAmountByMarine',
    DMMarineAction: environment.baseUrl + '/DMMarineAction',
    closeClaimByDMMarine: environment.baseUrl + '/CloseClaimByDMMarine',
    needClarificationByApprover: environment.baseUrl + '/needClarificationByApprover',
    needClarificationFromMarketPortQA: environment.baseUrl + '/needClarificationFromMarketPortQA',
    needClarificationFromFinance: environment.baseUrl + '/needClarificationFromFinance',
    sourceQaActionOnInlandClaim: environment.baseUrl + '/sourceQaActionOnInlandClaim',
    procurementActionOnInlandClaim: environment.baseUrl + '/procurementActionOnInlandClaim',
    procurementActionOnSalesClaim: environment.baseUrl + '/procurementActionOnSalesClaim',
    procurementActionOnClonedClaim: environment.baseUrl + '/procurementActionOnClonedClaim',
    getCompleteClaimById: environment.baseUrl + '/getCompleteClaimById',
    getClaimCreditNotes: environment.baseUrl + '/getClaimCreditNotes',
    deleteClaimProduct: environment.baseUrl + '/deleteClaimProduct',
    getClaimListForAdmin: environment.baseUrl + '/getClaimListForAdmin',
    deleteClaimForAdmin: environment.baseUrl + '/deleteClaimForAdmin'
}

export const patterns = {
    url: '(https?://).*?',
}

export interface LookupField {
    name: string;
    label: string;
    type: 'text' | 'number' | 'email' | 'tel' | 'url' | 'select' | 'multi-select';
    required: boolean;
    placeholder?: string;
    selectOptions?: SelectOption[];
    optionsEndpoint?: string;
    optionsMapping?: {
        value: string;
        label: string;
    };

    // Remote search configuration
    searchable?: boolean;          // Enable API-based search
    searchDebounceMs?: number;     // Default 300ms
    initialLimit?: number;         // Initial results (default 10)
    searchParam?: string;          // API search parameter (default 'name')

    // Field dependency configuration
    dependsOn?: string;            // Parent field name (e.g., 'region_id')
    dependencyParams?: (parentValue: any) => Record<string, any>;
    // Function that returns API params based on parent value
    // Example: (regionId) => ({ region_id: regionId })
}

export interface LookupConfig {
    label: string;
    fields: LookupField[];
    columns: TableColumn[];
    filterFields?: FilterField[];
    endpoints: {
        create: string;
        getAll: string;
        update: string;
        delete: string;
    };
}

export const lookupsConfig: Record<string, LookupConfig> = {
    item_uom: {
        label: 'Item UOM',
        fields: [{ name: 'name', label: 'Label', type: 'text', required: true, placeholder: 'Enter label' }],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Label' }
        ],
        filterFields: [
            { key: 'name', label: 'Label', type: 'text', placeholder: 'Search by label' }
        ],
        endpoints: {
            create: requests.createItemUom,
            getAll: requests.getAllItemUoms,
            update: requests.updateItemUom,
            delete: requests.deleteItemUom
        }
    },
    customer_category: {
        label: 'Customer Category',
        fields: [{ name: 'name', label: 'Label', type: 'text', required: true, placeholder: 'Enter label' }],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Label' }
        ],
        filterFields: [
            { key: 'name', label: 'Label', type: 'text', placeholder: 'Search by label' }
        ],
        endpoints: {
            create: requests.createCustomerCategory,
            getAll: requests.getAllCustomerCategories,
            update: requests.updateCustomerCategory,
            delete: requests.deleteCustomerCategory
        }
    },
    dm_sites: {
        label: 'DM Sites',
        fields: [{ name: 'code', label: 'Code', type: 'text', required: true, placeholder: 'Enter code' },
        {
            name: 'country_id',
            label: 'Country',
            type: 'select',
            required: true,
            placeholder: 'Select country',
            optionsEndpoint: requests.getAllCountries,
            optionsMapping: { value: 'id', label: 'name' },
            searchable: true,
            initialLimit: 100
        }
        ],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'code', label: 'Code' },
            { key: 'Country.name', label: 'Country' }
        ],
        filterFields: [
            { key: 'code', label: 'Code', type: 'text', placeholder: 'Search by code' },
            {
                key: 'country_id',
                label: 'Country',
                type: 'select',
                placeholder: 'Select country',
                optionsEndpoint: requests.getAllCountries,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10
            }
        ],
        endpoints: {
            create: requests.createDmSite,
            getAll: requests.getAllDmSites,
            update: requests.updateDmSite,
            delete: requests.deleteDmSite
        }
    },
    evidence_type: {
        label: 'Evidence Type',
        fields: [{ name: 'name', label: 'Label', type: 'text', required: true, placeholder: 'Enter label' }],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Label' }
        ],
        filterFields: [
            { key: 'name', label: 'Label', type: 'text', placeholder: 'Search by label' }
        ],
        endpoints: {
            create: requests.createEvidenceType,
            getAll: requests.getAllEvidenceTypes,
            update: requests.updateEvidenceType,
            delete: requests.deleteEvidenceType
        }
    },
    return_reason_codes: {
        label: 'Return Reason Codes',
        fields: [{ name: 'name', label: 'Label', type: 'text', required: true, placeholder: 'Enter label' }],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Label' }
        ],
        filterFields: [
            { key: 'name', label: 'Label', type: 'text', placeholder: 'Search by label' }
        ],
        endpoints: {
            create: requests.createReturnReasonCode,
            getAll: requests.getAllReturnReasonCodes,
            update: requests.updateReturnReasonCode,
            delete: requests.deleteReturnReasonCode
        }
    },
    ship_from_location: {
        label: 'Ship From Location',
        fields: [
            { name: 'code', label: 'Code', type: 'text', required: true, placeholder: 'Enter code' },
            { name: 'description', label: 'Description', type: 'text', required: true, placeholder: 'Enter description' },
            {
                name: 'region_id',
                label: 'Region',
                type: 'select',
                required: true,
                placeholder: 'Select region',
                optionsEndpoint: requests.getAllRegions,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10
            },
            {
                name: 'country_id',
                label: 'Country',
                type: 'select',
                required: true,
                placeholder: 'Select country',
                optionsEndpoint: requests.getAllCountries,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10,
                dependsOn: 'region_id',
                dependencyParams: (regionId) => ({ region_id: Number(regionId) })
            },
            {
                name: 'dm_site_id',
                label: 'DM Site',
                type: 'select',
                required: true,
                placeholder: 'Select DM Site',
                optionsEndpoint: requests.getAllDmSites,
                optionsMapping: { value: 'id', label: 'code' },
                searchable: true,
                searchParam: 'code',
                initialLimit: 10,
                dependsOn: 'country_id',
                dependencyParams: (countryId) => ({ country_id: Number(countryId) })
            },
            {
                name: 'product_category_id',
                label: 'Product Category',
                type: 'select',
                required: true,
                placeholder: 'Select product category',
                optionsEndpoint: requests.getAllProductCategories,
                optionsMapping: { value: 'id', label: 'name' }
            }
        ],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'code', label: 'Label' },
            { key: 'description', label: 'Description' },
            { key: 'Region.name', label: 'Region' },
            { key: 'DmSite.code', label: 'DM Site' },
            { key: 'Country.name', label: 'Country' },
            { key: 'ProductCategory.name', label: 'Product Category' }
        ],
        filterFields: [
            { key: 'description', label: 'Description', type: 'text', placeholder: 'Search by description' },
            {
                key: 'region_id',
                label: 'Region',
                type: 'select',
                placeholder: 'Select region',
                optionsEndpoint: requests.getAllRegions,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10,
                clearable: true
            },
            {
                key: 'country_id',
                label: 'Country',
                type: 'select',
                placeholder: 'Select country',
                optionsEndpoint: requests.getAllCountries,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10,
                dependsOn: 'region_id',
                dependencyParams: (regionId) => ({ region_id: Number(regionId) }),
                clearable: true
            },
            {
                key: 'dm_site_id',
                label: 'DM Site',
                type: 'select',
                placeholder: 'Select DM Site',
                optionsEndpoint: requests.getAllDmSites,
                optionsMapping: { value: 'id', label: 'code' },
                searchable: true,
                searchParam: 'code',
                initialLimit: 10,
                dependsOn: 'country_id',
                dependencyParams: (countryId) => ({ country_id: Number(countryId) }),
                clearable: true
            }
        ],
        endpoints: {
            create: requests.createShipFromLocation,
            getAll: requests.getAllShipFromLocations,
            update: requests.updateShipFromLocation,
            delete: requests.deleteShipFromLocation
        }
    },
    size: {
        label: 'Size',
        fields: [{ name: 'name', label: 'Label', type: 'text', required: true, placeholder: 'Enter label' }],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Label' }
        ],
        filterFields: [
            { key: 'name', label: 'Label', type: 'text', placeholder: 'Search by label' }
        ],
        endpoints: {
            create: requests.createSize,
            getAll: requests.getAllSizes,
            update: requests.updateSize,
            delete: requests.deleteSize
        }
    },
    variety: {
        label: 'Variety',
        fields: [{ name: 'name', label: 'Label', type: 'text', required: true, placeholder: 'Enter label' }],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Label' }
        ],
        filterFields: [
            { key: 'name', label: 'Label', type: 'text', placeholder: 'Search by label' }
        ],
        endpoints: {
            create: requests.createVariety,
            getAll: requests.getAllVarieties,
            update: requests.updateVariety,
            delete: requests.deleteVariety
        }
    },
    brand: {
        label: 'Brand',
        fields: [{ name: 'name', label: 'Label', type: 'text', required: true, placeholder: 'Enter label' }],
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Label' }
        ],
        filterFields: [
            { key: 'name', label: 'Label', type: 'text', placeholder: 'Search by label' }
        ],
        endpoints: {
            create: requests.createBrand,
            getAll: requests.getAllBrands,
            update: requests.updateBrand,
            delete: requests.deleteBrand
        }
    },
    group_description_codes: {
        label: 'Group Description Code',
        fields: [{ name: 'code', label: 'Code', type: 'text', required: true, placeholder: 'Enter code' },
        { name: 'description', label: 'Description', type: 'text', required: true, placeholder: 'Enter description' }],
        columns: [
            { key: 'code', label: 'Code' },
            { key: 'description', label: 'Description' }
        ],
        filterFields: [
            { key: 'code', label: 'Code', type: 'text', placeholder: 'Search by code' },
            { key: 'description', label: 'Description', type: 'text', placeholder: 'Search by description' }
        ],
        endpoints: {
            create: requests.createGroupDescriptionCode,
            getAll: requests.getAllGroupDescriptionCodes,
            update: requests.updateGroupDescriptionCode,
            delete: requests.deleteGroupDescriptionCode
        }
    },
    reason_codes: {
        label: 'Reason Codes',
        fields: [
            { name: 'code', label: 'Code', type: 'text', required: true, placeholder: 'Enter code' },
            { name: 'description', label: 'Description', type: 'text', required: true, placeholder: 'Enter description' },
            {
                name: 'group_description_code_id',
                label: 'Group Description Code',
                type: 'select',
                required: true,
                placeholder: 'Select group description code',
                optionsEndpoint: requests.getAllGroupDescriptionCodes,
                optionsMapping: { value: 'id', label: 'description' },
                searchParam: 'description',
                searchable: true,
                initialLimit: 100
            }],
        columns: [
            { key: 'code', label: 'Code' },
            { key: 'description', label: 'Description' },
            { key: 'GroupDescriptionCode.code', label: 'Group Description Code' },
            { key: 'GroupDescriptionCode.description', label: 'Group Description' }
        ],
        filterFields: [
            { key: 'code', label: 'Code', type: 'text', placeholder: 'Search by code' },
            { key: 'description', label: 'Description', type: 'text', placeholder: 'Search by description' },
            { key: 'GroupDescriptionCode.code', label: 'Group Description Code', type: 'text', placeholder: 'Search by group desc. code' },
            { key: 'GroupDescriptionCode.description', label: 'Group Description', type: 'text', placeholder: 'Search by group desc.' }
        ],
        endpoints: {
            create: requests.createReasonCode,
            getAll: requests.getAllReasonCodes,
            update: requests.updateReasonCode,
            delete: requests.deleteReasonCode
        }
    }
}

export interface MassUploadConfig {
    label: string;
    columns: TableColumn[];
    filterFields?: FilterField[];
    endpoint: string;
    uploadEndpoint?: string;
    templateEndpoint?: string;   
}

export const massUploadConfig: Record<string, MassUploadConfig> = {
    product: {
        label: 'Product',
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'local_item_code', label: 'Item Code' },
            { key: 'item_description', label: 'Item Description' },
            { key: 'ProductCategory.name', label: 'Product Category' },
            { key: 'ProductType.name', label: 'Product Type' },
            { key: 'Region.name', label: 'Region' },
            { key: 'Country.name', label: 'Country' },
            { key: 'Brand.name', label: 'Brand' },
            { key: 'Variety.name', label: 'Variety' },
            { key: 'Size.name', label: 'Size' },
            { key: 'ItemUom.name', label: 'UOM' },
            { key: 'item_source_code', label: 'Item Source Code' },
            { key: 'item_source_description', label: 'Item Source Description' },
            { key: 'packaging_spec_code', label: 'Packaging Spec Code' },
            { key: 'shelf_life', label: 'Shelf Life' },
            { key: 'certificate_number', label: 'Certificate Number' },
            { key: 'is_bio_organic', label: 'Bio Organic' },
            { key: 'is_rfa', label: 'Rfa' },
            { key: 'is_fairtrade', label: 'Fair Trade' },
            { key: 'is_internal', label: 'Internal' },
        ],
        filterFields: [
            { key: 'item_description', label: 'Item Description', type: 'text', placeholder: 'Search by description' },
            {
                key: 'product_category_id',
                label: 'Product Category',
                type: 'select',
                placeholder: 'Select product category',
                optionsEndpoint: requests.getAllProductCategories,
                optionsMapping: { value: 'id', label: 'name' }
            },
            {
                key: 'region_id',
                label: 'Region',
                type: 'select',
                placeholder: 'Select region',
                optionsEndpoint: requests.getAllRegions,
                optionsMapping: { value: 'id', label: 'name' }
            },
            {
                key: 'country_id',
                label: 'Country',
                type: 'select',
                placeholder: 'Select country',
                optionsEndpoint: requests.getAllCountries,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10,
                dependsOn: 'region_id',
                dependencyParams: (regionId) => ({ region_id: Number(regionId) })
            },
            {
                key: 'brand',
                label: 'Brand',
                type: 'text',
                placeholder: 'Search by brand',
                // optionsEndpoint: requests.getAllBrands,
                // optionsMapping: { value: 'id', label: 'name' },
                // searchable: true,
                // initialLimit: 10
            },
            {
                key: 'variety',
                label: 'Variety',
                type: 'text',
                placeholder: 'Search by variety',
                // optionsEndpoint: requests.getAllVarieties,
                // optionsMapping: { value: 'id', label: 'name' },
                // searchable: true,
                // initialLimit: 10
            },
            {
                key: 'local_item_code',
                label: 'Item Code',
                type: 'text',
                placeholder: 'Search by item code',
                // optionsEndpoint: requests.getAllProductLocalItemCodes,
                // optionsMapping: { value: 'id', label: 'local_item_code' },
                // searchParam: 'local_item_code',
                // searchable: true,
                // initialLimit: 10
            }
        ],
        endpoint: requests.getAllProducts,
        uploadEndpoint: requests.importProductsFromFile,
        templateEndpoint: requests.getProductTemplate, 
    },
    customer: {
        label: 'Customer',
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Name' },
            { key: 'number', label: 'Customer Number' },
            { key: 'email', label: 'Email' },
            { key: 'CustomerCategory.name', label: 'Customer Category' },
            { key: 'ProductCategory.name', label: 'Product Category' },
            { key: 'Currency.code', label: 'Currency' },
            { key: 'Region.name', label: 'Region' },
            { key: 'Country.name', label: 'Country' },
            { key: 'DmSite.code', label: 'DM Site' },
            { key: 'Application.name', label: 'Application' }
        ],
        filterFields: [
            { key: 'name', label: 'Name', type: 'text', placeholder: 'Search by name' },
            {
                key: 'customer_category_id',
                label: 'Customer Category',
                type: 'select',
                placeholder: 'Select customer category',
                optionsEndpoint: requests.getAllCustomerCategories,
                optionsMapping: { value: 'id', label: 'name' }
            },
            {
                key: 'product_category_id',
                label: 'Product Category',
                type: 'select',
                placeholder: 'Select product category',
                optionsEndpoint: requests.getAllProductCategories,
                optionsMapping: { value: 'id', label: 'name' }
            },
            {
                key: 'region_id',
                label: 'Region',
                type: 'select',
                placeholder: 'Select region',
                optionsEndpoint: requests.getAllRegions,
                optionsMapping: { value: 'id', label: 'name' }
            },
            {
                key: 'country_id',
                label: 'Country',
                type: 'select',
                placeholder: 'Select country',
                optionsEndpoint: requests.getAllCountries,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10,
                dependsOn: 'region_id',
                dependencyParams: (regionId) => ({ region_id: Number(regionId) })
            },
            {
                key: 'dm_site_id',
                label: 'DM Site',
                type: 'select',
                placeholder: 'Select DM Site',
                optionsEndpoint: requests.getAllDmSites,
                optionsMapping: { value: 'id', label: 'code' },
                searchable: true,
                searchParam: 'code',
                initialLimit: 10,
                dependsOn: 'country_id',
                dependencyParams: (countryId) => ({ country_id: Number(countryId) })
            },
            {
                key: 'currency_id',
                label: 'Currency',
                type: 'select',
                placeholder: 'Select currency',
                optionsEndpoint: requests.getAllCurrencies,
                optionsMapping: { value: 'id', label: 'code' },
                searchParam: 'code',
                searchable: true,
                initialLimit: 10
            },
            {
                key: 'number',
                label: 'Customer Number',
                type: 'text',
                placeholder: 'Search by customer number',
                // optionsEndpoint: requests.getAllCustomerNumbers,
                // optionsMapping: { value: 'id', label: 'number' },
                // searchParam: 'number',
                // searchable: true,
                // initialLimit: 10
            }
        ],
        endpoint: requests.getAllCustomers,
        uploadEndpoint: requests.importCustomersFromFile,
        templateEndpoint: requests.getCustomerTemplate,
    },
    vendor: {
        label: 'Vendor',
        columns: [
            { key: 'id', label: 'ID', width: '80px' },
            { key: 'name', label: 'Name' },
            { key: 'vendor_number', label: 'Vendor Number' },
            { key: 'vendor_type_value', label: 'Vendor Type' },
            { key: 'ProductCategory.name', label: 'Product Category' },
            { key: 'Region.name', label: 'Region' },
            { key: 'marketCountry.name', label: 'Market Country' },
            { key: 'DmSite.code', label: 'DM Site' },
            { key: 'Application.name', label: 'Application' },
            { key: 'Currency.code', label: 'Currency' },
            { key: 'payToCountry.name', label: 'Pay To Country' },
            { key: 'pay_to_address_1', label: 'Pay To Address 1' },
            { key: 'pay_to_address_2', label: 'Pay To Address 1' },
            { key: 'pay_to_contact_name', label: 'Pay To Contact Name' },
            { key: 'pay_to_contact_email', label: 'Pay To Contact Email' },
            { key: 'pay_to_contact_phone', label: 'Pay To Contact Phone' }
        ],
        filterFields: [
            { key: 'name', label: 'Name', type: 'text', placeholder: 'Search by name' },
            {
                key: 'product_category_id',
                label: 'Product Category',
                type: 'select',
                placeholder: 'Select product category',
                optionsEndpoint: requests.getAllProductCategories,
                optionsMapping: { value: 'id', label: 'name' }
            },
            {
                key: 'region_id',
                label: 'Region',
                type: 'select',
                placeholder: 'Select region',
                optionsEndpoint: requests.getAllRegions,
                optionsMapping: { value: 'id', label: 'name' }
            },
            {
                key: 'country_market_id',
                label: 'Market Country',
                type: 'select',
                placeholder: 'Select market country',
                optionsEndpoint: requests.getAllCountries,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10,
                dependsOn: 'region_id',
                dependencyParams: (regionId) => ({ region_id: Number(regionId) })
            },
            {
                key: 'dm_site_id',
                label: 'DM Site',
                type: 'select',
                placeholder: 'Select DM Site',
                optionsEndpoint: requests.getAllDmSites,
                optionsMapping: { value: 'id', label: 'code' },
                searchable: true,
                searchParam: 'code',
                initialLimit: 10,
                dependsOn: 'country_market_id',
                dependencyParams: (countryId) => ({ country_id: Number(countryId) })
            },
            {
                key: 'currency_id',
                label: 'Currency',
                type: 'select',
                placeholder: 'Select currency',
                optionsEndpoint: requests.getAllCurrencies,
                optionsMapping: { value: 'id', label: 'code' },
                searchParam: 'code',
                searchable: true,
                initialLimit: 10
            },
            {
                key: 'pay_address3_country_id',
                label: 'Pay To Country',
                type: 'select',
                placeholder: 'Select pay to country',
                optionsEndpoint: requests.getAllCountries,
                optionsMapping: { value: 'id', label: 'name' },
                searchable: true,
                initialLimit: 10
                // Independent of Region: pay-to country is not scoped to the
                // selected region, so it always lists all countries.
            },
            {
                key: 'number',
                label: 'Vendor Number',
                type: 'text',
                placeholder: 'Search by vendor number',
                // optionsEndpoint: requests.getAllVendorNumbers,
                // optionsMapping: { value: 'id', label: 'vendor_number' },
                // searchParam: 'vendor_number',
                // searchable: true,
                // initialLimit: 10
            }
        ],
        endpoint: requests.getAllVendors,
        uploadEndpoint: requests.importVendorsFromFile,
        templateEndpoint: requests.getVendorTemplate,
    }
}